import React, { createContext, useState, useEffect, useContext } from 'react';
import { loginUser, logoutUser, getCurrentUser, isAuthenticated } from '../services/API';

// Crear el contexto
const AuthContext = createContext();

// Hook personalizado para usar el contexto de autenticación
export const useAuth = () => {
    return useContext(AuthContext);
};

// Proveedor del contexto de autenticación
export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Inicializar estado de autenticación al cargar
    useEffect(() => {
        const initAuth = async () => {
            if (isAuthenticated()) {
                try {
                    const user = await getCurrentUser();
                    setCurrentUser(user);
                } catch (err) {
                    console.error("Error fetching current user:", err);
                    logoutUser(); // Limpiar si hay error
                }
            }
            setLoading(false);
        };

        initAuth();
    }, []);

    // Función para iniciar sesión
    const login = async (credentials) => {
        try {
            setError(null);
            await loginUser(credentials);
            const user = await getCurrentUser();
            setCurrentUser(user);
            return { success: true, user };
        } catch (err) {
            setError(err.message);
            return { success: false, error: err.message };
        }
    };

    // Function to sign out
    const logout = () => {
        logoutUser();
        setCurrentUser(null);
    };

    // Objeto con valores del contexto
    const value = {
        currentUser,
        isAuthenticated: !!currentUser,
        loading,
        error,
        login,
        logout
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
